import { render, staticRenderFns } from "./VAB.vue?vue&type=template&id=65eb993e&"
import script from "./VAB.vue?vue&type=script&lang=js&"
export * from "./VAB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports